import React from "react";

const ConditionSetHelp = () => {
  return (
    <React.Fragment>
      <div>
        The condition for which the variant is interpreted. The condition must
        be provided as either a database identifier or a name, but not both.
      </div>
      <div>
        A database identifier is preferred by ClinVar; a name should be provided
        only if there is no database identifier available. Detailed information
        about about reporting condition is available{" "}
        <a
          href="https://www.ncbi.nlm.nih.gov/clinvar/docs/faq_submitters/#pheno"
          target="_blank"
        >
          here
        </a>
        .
      </div>
      <div>
        If multiple conditions are submitted for a variant, this indicates that
        the variant was interpreted for the combination of conditions in the
        same individual(s). i.e. this variant causes both condition A and
        condition B in the same individual. This scenario is most common for a
        new disease or syndrome that does not yet have a name and is described
        by several clinical features. If you want to indicate that the variant
        has been interpreted for more than one condition, please submit these as
        separate records. i.e. this variant causes condition A in some
        individuals and causes disease B in other individuals. Provide only one
        name or identifier for a condition; do not provide multiple names or
        identifiers for the same condition.
      </div>
    </React.Fragment>
  );
};

export default ConditionSetHelp;
